import React, { Component, Suspense } from 'react';
// import Sidemenu from "../headerComponents/sidemenuLokal"
import menu from "../images/lokal/menu.png"
import $ from "jquery";
import { Link } from 'react-router-dom';
let Sidemenu = React.lazy(() => import("../headerComponents/sidemenuLokal"))
export default class HeaderLogo extends Component {
    componentDidMount() {
        $(".toggle").click(function () {
            $(".sideMenuDiv").show();
        });
        $(".menuClose").click(function () {
            $(".sideMenuDiv").hide();
        });
    }
    render() {
        let themeId = localStorage.getItem('themeId')
        $("#defaultBannerLoad").hide();
        return (
            <div className={"headerLeft " + (this.props.fromPage === "Lokal" ? "lokalHeaderLeft" : "")}>
                {themeId == '33' ? "" :
                    <Suspense fallback={<div></div>}>
                        <div className="sideMenuDiv"><Sidemenu></Sidemenu></div>
                    </Suspense>}

                {/* {this.props.fromPage === "Lokal" ? "" : <div className="toggle"><img src={menu} alt="logo"/></div> } */}

                <div className="logo">
                    <Link to="/"><img src={this.props.storeLogoPath} alt="logo" /></Link>
                </div>
            </div>
        )
    }
}